import { useEffect, useState } from "react";

const navLinks = [
  { label: "Shop", href: "#shop" },
  { label: "Characters", href: "#characters" },
  { label: "Story", href: "#story" },
  { label: "Journal", href: "#journal" },
  { label: "Contact", href: "#contact" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 bg-white ${
        scrolled ? "border-b border-neutral-200/70" : ""
      }`}
    >
      <nav className="w-full px-6 md:px-12 h-20 flex items-center justify-between">
        {/* Logo */}
        <a
          href="#"
          className="flex items-center gap-2.5 font-display text-2xl tracking-tight whitespace-nowrap cursor-pointer text-neutral-900"
        >
          <span className="w-9 h-9 flex items-center justify-center rounded-full bg-[#f4d35e]">
            <i className="ri-star-fill text-neutral-900 text-base"></i>
          </span>
          <span className="italic">Little Star</span>
        </a>

        {/* Desktop Links */}
        <ul className="hidden md:flex items-center gap-9">
          {navLinks.map((link) => (
            <li key={link.label}>
              <a
                href={link.href}
                className="text-[13px] font-medium tracking-wide whitespace-nowrap cursor-pointer transition-colors text-neutral-600 hover:text-neutral-900"
              >
                {link.label}
              </a>
            </li>
          ))}
        </ul>

        {/* CTA */}
        <div className="hidden md:flex items-center gap-3">
          <button
            className="w-10 h-10 flex items-center justify-center rounded-full cursor-pointer transition-all text-neutral-700 hover:bg-neutral-100"
            aria-label="Search"
          >
            <i className="ri-search-line text-lg"></i>
          </button>
          <a
            href="#shop"
            className="relative text-[13px] font-semibold px-5 py-2.5 rounded-full whitespace-nowrap cursor-pointer transition-all bg-neutral-900 text-white hover:bg-neutral-800"
          >
            Shop Now
          </a>
        </div>

        {/* Mobile burger */}
        <button
          onClick={() => setMenuOpen(!menuOpen)}
          className="md:hidden w-10 h-10 flex items-center justify-center cursor-pointer text-neutral-900"
          aria-label="Open menu"
        >
          <i className={`text-2xl ${menuOpen ? "ri-close-line" : "ri-menu-line"}`}></i>
        </button>
      </nav>

      {/* Mobile menu */}
      {menuOpen && (
        <div className="md:hidden bg-white border-t border-neutral-200 px-6 py-5">
          <ul className="flex flex-col gap-4">
            {navLinks.map((link) => (
              <li key={link.label}>
                <a
                  href={link.href}
                  onClick={() => setMenuOpen(false)}
                  className="block text-base text-neutral-800 hover:text-neutral-600 cursor-pointer"
                >
                  {link.label}
                </a>
              </li>
            ))}
            <li>
              <a
                href="#shop"
                onClick={() => setMenuOpen(false)}
                className="inline-block mt-2 bg-neutral-900 text-white text-sm font-semibold px-5 py-2.5 rounded-full whitespace-nowrap cursor-pointer"
              >
                Shop Now
              </a>
            </li>
          </ul>
        </div>
      )}
    </header>
  );
}